import React from "react";
import image from "../../assets/images/dean-edge.jpeg";

export default function DeanResearch() {
  return (
    <>
      <section
        className="section"
        style={{
          position: "relative",
          top: "185px",
          marginBottom: "20vh",
          marginTop: "10vh",
          padding: "2rem",
        }}
      >
        <div className="centered-image">
          <div>
            <h1 style={{ textAlign: "center" }}>Dean EDGE</h1>
            <h2 style={{ textAlign: "center" }}>Prof. Dr. Satyendra Patnaik</h2>
          </div>
          <div>
            <img
              src={image}
              alt="Controller of Examinations Dr. Shiddayya S Shirur"
              style={{
                width: "100%",
                height: "100%",
                minWidth: "300px",
                minHeight: "200px",
                maxWidth: "600px",
                maxHeight: "400px",
              }}
            />
          </div>
        </div>
        <br />
        <div style={{ textAlign: "center", marginTop: "30px" }}>
          <p>satyendra.patnaik@jssuninoida.edu.in</p>
        </div>
        <br />
        <p
          className=""
          style={{
            textAlign: "justify",
            fontSize: "1.2em",
          }}
        >
          Prof. Dr. Satyendra Patnaik, serves as the Dean – EDGE
          (Entrepreneurship & Global Alliances) is a dynamic ecosystem builder
          committed to nurturing early-stage startups and driving innovation-led
          entrepreneurship. With a background in venture creation and startup
          mentoring, they oversee incubation programs, investor relations, and
          startup acceleration initiatives. His leadership has catalyzed the
          launch of successful startups across sectors including deep tech,
          sustainability, and digital health. He actively fosters
          university-industry linkages and promotes student entrepreneurship
          through structured mentorship, seed funding, and scale-up support. He
          is also spearheading the university’s internationalization strategy.
          With extensive experience in global academic partnerships, they lead
          initiatives related to student/faculty exchange, dual-degree programs,
          global research collaborations, and strategic MoUs, with a mission to
          build a globally competitive academic environment that empowers
          students with global exposure and multicultural perspectives. Along
          with this role, he is also heading the School of Management at JSS
          University Noida, where he leads the academic strategy, curriculum
          innovation, and industry collaboration to develop future-ready
          leaders. With over 27 years of experience in management education,
          Prof. Patnaik is a visionary academic and practitioner with a focus on
          entrepreneurship, business analytics, and leadership development.
          Under their stewardship, the school sees to record growth in student
          outcomes, corporate partnerships, and global rankings.
          <br />
          <br />
          Prof. Dr. Satyendra Patnaik
          <br />
          Dean EDGE
          <br />
          JSS University, Noida
        </p>
      </section>
    </>
  );
}
